import { postResource, getResource } from '../utils/ConfigMethode';

const PdvController = {
  // Assurez-vous que PdvListe accepte page, rowsPerPage et searchdata
  ModifierPassword: (data) => postResource(`update/User/Password`, data),
  ProfileUser: (token) => getResource(`user/info`, token),
};

export default PdvController
